import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=3b9da4c0&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=3b9da4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9da4c0",
  null
  
)

export default component.exports